/*
 * @Author: lyx
 * @Date: 2024-08-13 10:25:17
 * @LastEditors: lyx
 * @LastEditTime: 2024-08-13 11:14:04
 * @FilePath: /dbrank_b/src/routes/visualChart/P28/chart.js
 */

import { flatten } from "lodash";
import { xAxisLabelColor, yAxisLabelColor } from "../visualConfig";
import getGap from "../getGap";
import { toVisualThousands } from "../utils";
import { dropRight } from "lodash";
// import { textAlign } from "html2canvas/dist/types/css/property-descriptors/text-align";
function iData(data) {
  let max = Math.max.apply(null, data);
  let iData = data.map((item) => {
    return (max - item) / 2;
  });
  return iData;
}

const createTitle = (list = []) => {
  const len = list.length;
  const _width = 100 / len;
  let arr = list.map((item, index) => {
    const left = `${index * _width}%`;
    const width = `30%`;
    return {
      text: item.name + '内容篇数分布',
      left: `${_width * index + _width / 3.3}%`,
      // width: width,
      textAlign: 'left',
      textStyle: {
        fontSize: 20,
        fontWeight: "bold",
        color: "#000",
      },
    };
  });
  return arr;
};
const createGrid = (list = []) => {
  const len = list.length;
  const offsetLeft = 5;
  const _width = 100 / len;

  return list.map((_, index) => {
    const width = `23%`;
    const left = `${index * _width + offsetLeft}%`;

    return {
      id: index,
      top: "10%",
      bottom: 20,
      left: index !== 0 ? left : '7%',
      // width: `${100 /len-offsetLeft}%`,
      width,
      right: '30%',
      containLabel: false
    };
  });
};
const createYAxis = (list = [], chartAxis = []) => {
  return list.map((item, index) => ({
    data: chartAxis.map((item)=>{
      return item.trim() + '内容'
    }),
    axisLabel:{
      show: true,
      textStyle: {
        fontSize: 16,
        fontWeight: "bold",
        color: yAxisLabelColor,
      }
    }, 
    inverse: true,
    gridIndex: index,
    type: "category",
    
    axisTick: { show: false },
    axisLine: { show: true, lineStyle:{color: "#eee"} },
    splitLine: { show: false },
  }));
};

const createXAxis = (list = []) => {
  let arr = list.map((item, index) => ({
    type: "value",
    show: false,
    gridIndex: index,
    axisLabel: {show: false},
    axisLine: { show: false },
    axisTick: { show: false },
    minorTick: { show: false },
    splitLine: { show: false },
    max: function (value) {
        return Math.max.apply(null, item.list);
      },
  }));
  return arr;
};

const createSeries = (list = [], color = []) => {

  return flatten(list.map((item, index) => (
    [{
      name: "辅助",
      type: "bar",
      stack: "总量"+index,
      xAxisIndex: index,
      yAxisIndex: index,
      label: {
        color: "rgba(0,0,0,0)",
      },
      itemStyle: {
        normal: {
          barBorderColor: "rgba(0,0,0,0)",
          color: "rgba(0,0,0,0)",
        },
        emphasis: {
          barBorderColor: "rgba(0,0,0,0)",
          color: "rgba(0,0,0,0)",
        },
      },
      data: iData(item.list),
    },
    {
      name:'',
      type: "bar",
      stack: "总量"+index,
      xAxisIndex: index,
      yAxisIndex: index,
      barCategoryGap: "5%",
      // data: item.list,
      data: item.list.map((item,index) =>{
        return{
          value: item,
          label: {
            textStyle: { color: index === 0 || index === 1 ? '#000' : '#fff' }
          }
        }
    }),
      label: {
        fontSize: 14,
        fontWeight: 550,
        formatter: (ele) => toVisualThousands(ele.value),
      },
      itemStyle: {
        normal: {
          color: color[index],
        },
      },
    }]
  )));
};

export default ({chartAxis, chartList = [], color = [] }) => {
  // console.log('chartAxis',chartAxis);
  // console.log('chartList',chartList);
  // console.log('color',color);
  // 遍历chartList数组，创建echarts柱状图配置项
  // chartList.forEach((item,index) => {
  //   // （最后一条数据是好感度，需要特殊处理，放到最前面）
  //   // 图表名称： item.name+'类内容条数'
  //   // 图标纵轴：brandList的数据
  //   // 图标数据：item.list的数据

  // });
  // const list = dropRight(chartAxis);
  if (chartAxis && chartAxis.length == 0) return {};
  return {
    title: createTitle(chartList),
    grid: createGrid(chartList),
    yAxis: createYAxis(chartList, chartAxis),
    xAxis: createXAxis(chartList),
    series: createSeries(chartList, color)
  };
};



// WEBPACK FOOTER //
// src/routes/visualChart/P31/chart.js